module.exports = "/assets/data/9f1e0b242a5ab5afaf2c6df789d9ab7f-HU3.data.json";